import {Component, Inject, inject} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogClose,
  MatDialogTitle,
  MatDialogContent,
} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { TablerIconsModule } from 'angular-tabler-icons';

@Component({
  selector: 'app-modals-file-view',
  imports: [CdkDrag,
    CdkDragHandle, MatDialogClose, MatDialogTitle, MatDialogContent, MatButtonModule,TablerIconsModule],
  standalone: true,
  templateUrl: './modals-file-view.component.html',
  styleUrl: './modals-file-view.component.scss'
})
export class ModalsFileViewComponent {

  private sanitizer: DomSanitizer = inject(DomSanitizer);

  private dialogRef: MatDialogRef<ModalsFileViewComponent> = inject(MatDialogRef);
  public dataModule;
  public contentType;
  public fileData: SafeResourceUrl = '';

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.dataModule = data;
    const blob = this.dataModule.data;
    this.contentType = blob.type;
    const blobUrl = URL.createObjectURL(blob);
    this.fileData = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);

  }

  close(): void {
    this.dialogRef.close();
  }

}
